export function clients(state) {
  return state.clients;
}

export function especialidades(state) {
  return state.especialidades;
}

export function certificates(state) {
  return state.certificates;
}

export function tools(state) {
  return state.tools;
}







